import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../components/ui/BackDrop";
import { cn } from "../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { closeIcon } from "../../assetData/icons";
import RadioButton from "../ui/RadioButton";
import MemberSearchDropdown from "../ui/MemberSearchDropdown";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import MirageLoader from "../ui/pageLoader/MirageLoader";
const getUserData = `${process.env.REACT_APP_API_URL}api/user-data`;
const confirmSubscriber = `${process.env.REACT_APP_API_URL}api/impersonate_subscriber/`;

const DashboardChooseMember = ({ buttonConfig }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const prevState = location.state || {};

  const closeHandler = buttonConfig.closeHandler;
  const [selectedRadio, setSelectedRadio] = useState();
  const [subscriberData, setSubscriberData] = useState();
  const [subscriberFilteredData, setSubscriberFilteredData] = useState([]);
  const [subscriberId, setSubscriberId] = useState();
  const [subscriberName, setSubscriberName] = useState();
  const [dataFetching, setDataFetching] = useState();
  const [isButtonClicked, setIsButtonClicked] = useState();

  const apiOption = {
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
    },
  };

  const getSubscriberList = async () => {
    setDataFetching("fetching");
    try {
      const res = await axios.get(getUserData, apiOption);
      setSubscriberData(res.data);
      setDataFetching("fetched");
    } catch (error) {
      setDataFetching(false);
    }
  };

  useEffect(() => {
    getSubscriberList();
  }, []);

  useEffect(() => {
    const unique = {};
    if (selectedRadio === "member") {
      const uniqueData = subscriberData?.members
        ?.flat()
        ?.filter((item) => {
          if (!unique[item.full_name]) {
            unique[item.full_name] = true;
            return true;
          }
          return false;
        })
        ?.map((item) => ({
          id: item.id,
          ucc: item?.ucc || null,
          name: item.full_name,
        }));
      setSubscriberFilteredData(uniqueData);
    } else if (selectedRadio === "family") {
      const uniqueData = subscriberData?.family
        ?.flat()
        ?.filter((item) => {
          if (!unique[item.family_name]) {
            unique[item.family_name] = true;
            return true;
          }
          return false;
        })
        ?.map((item) => ({
          id: item.family_id,
          ucc: item?.ucc || null,
          name: item.family_name,
        }));
      setSubscriberFilteredData(uniqueData);
    } else if (selectedRadio === "group") {
      const uniqueData = subscriberData?.group
        ?.flat()
        ?.filter((item) => {
          if (!unique[item.group_name]) {
            unique[item.group_name] = true;
            return true;
          }
          return false;
        })
        ?.map((item) => ({
          id: item.group_id,
          ucc: item?.ucc || null,
          name: item.group_name,
        }));
      setSubscriberFilteredData(uniqueData);
    }
  }, [subscriberData, selectedRadio]);

  const schema = z.object({
    id: z.string().nonempty(),
    description: z.string().nonempty(),
    coupon_code: z.string().nonempty(),
    unit: z.string().nonempty(),
    type: z.string(),
    value: z.string(),
    nse_lot: z.string(),
    nse_face_value: z.string(),
    bse_code: z.string(),
    bse_lot: z.string(),
    bse_face_value: z.string(),
    bse_group: z.string(),
    script_type_name: z.string().nonempty(),
    asset_class_name: z.string().nonempty(),
    vidal_sector_code: z.string().nonempty(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const handleSubmit = async () => {
    setIsButtonClicked(true);
    try {
      if (subscriberId?.value) {
        const res = await axios.post(
          confirmSubscriber,
          {
            [subscriberId?.key]: subscriberId?.value,
          },
          apiOption,
        );
        if (res.data.token.access) {
          if (subscriberId?.key === "subscriber_id") {
            sessionStorage.setItem("subscriberToken", res.data.token.access);
            sessionStorage.setItem("subscriberName", subscriberName);
            sessionStorage.setItem("selectedRadio", selectedRadio);
            sessionStorage.setItem("selectedId", subscriberId?.value);
          } else {
            sessionStorage.setItem("subscriberToken", res.data.token.access);
            sessionStorage.setItem(
              "SubscriberPermissions",
              JSON.stringify(res?.data?.permissions),
            );
            sessionStorage.setItem("subscriberName", subscriberName);
            sessionStorage.setItem("selectedRadio", selectedRadio);
            sessionStorage.setItem("subscriberId", subscriberId?.value);
          }
          sessionStorage.removeItem("contractData");
          navigate("/UzAJ/y4fN/kdSuVuxGEcEw==", {
            replace: true,
            state: {
              ...prevState,
              workingFinYear: true,
              permittedFyList: true,
              brokerApi: true,
            },
          });
          setIsButtonClicked(false);
          closeHandler()
        } else {
          setIsButtonClicked(false);
        }
      }
    } catch (error) {
      console.error(error);
      setIsButtonClicked(false);
    }
  };

  const onClose = () => {
    closeHandler();
  };

  const handleTimeChange = (e) => {
    setSelectedRadio(e);
  };

  const handleSeletedSub = (value, key) => {
    if (value && key) {
      const values = value?.split(",");
      setSubscriberId({ key: key, value: Number(values[0]) });
      setSubscriberName(values[1]);
    } else {
      setSubscriberId({ key: null, value: null });
      setSubscriberName();
    }
  };
  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-[400] mx-auto min-h-[300px] w-[98%] max-w-[800px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Choose Member | Family | Group
        </h2>

        <button
          type="button"
          className="absolute top-8 max-md:right-2 md:right-8"
          onClick={onClose}
        >
          <img src={closeIcon} alt="" />
        </button>

        <div>
          {/* row 1 */}
          <div className="mt-6 flex max-sm:gap-4 sm:gap-14">
            <div className="flex items-center gap-0">
              <RadioButton
                label="Member"
                value="member"
                onChange={(e) => handleTimeChange(e)}
              />
            </div>
            <div className="flex items-center gap-0">
              <RadioButton
                label="Family"
                value="family"
                onChange={(e) => handleTimeChange(e)}
              />
            </div>
            <div className="flex items-center gap-0">
              <RadioButton
                label="Group"
                value="group"
                onChange={(e) => handleTimeChange(e)}
              />
            </div>
          </div>

          {/* row 2 */}
          <div className="mt-8 gap-2 sm:flex max-sm:[&>div>]:mt-4">
            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Member Name</label>
              <MemberSearchDropdown
                dataFetching={dataFetching}
                selectedRadio={selectedRadio}
                OnChange={(e) => handleSeletedSub(e, "subscriber_id")}
                className={cn(
                  "bg-dropdown text-dropdown-text h-full rounded p-2 px-2 placeholder:italic focus:outline-none",
                  errors.id && "border-[1px] border-red-300",
                )}
                placeHolder={"Member"}
                optionData={subscriberFilteredData}
              />
            </div>

            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Family Name</label>
              <MemberSearchDropdown
                dataFetching={dataFetching}
                selectedRadio={selectedRadio}
                OnChange={(e) => handleSeletedSub(e, "family_id")}
                className={cn(
                  "bg-dropdown text-dropdown-text h-full rounded p-2 px-2 placeholder:italic focus:outline-none",
                  errors.id && "border-[1px] border-red-300",
                )}
                placeHolder={"Family"}
                optionData={subscriberFilteredData}
              />
            </div>

            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Group Name</label>
              <MemberSearchDropdown
                dataFetching={dataFetching}
                OnChange={(e) => handleSeletedSub(e, "group_id")}
                className={cn(
                  "bg-dropdown text-dropdown-text h-full rounded p-2 px-2 placeholder:italic focus:outline-none",
                  errors.id && "border-[1px] border-red-300",
                )}
                placeHolder={"Group"}
                selectedRadio={selectedRadio}
                optionData={subscriberFilteredData}
              />
            </div>
          </div>

          {/* action */}
          <div className="mt-6 flex items-end justify-between gap-2 [&>button]:w-1/3">
            <button
              disabled={!subscriberId?.value || isButtonClicked}
              onClick={() => handleSubmit()}
              className={` ${
                !subscriberId?.value || isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-12 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "Confirm"}
            </button>
          </div>
        </div>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default DashboardChooseMember;
